// Part B (#1572): proactive send-readiness hint shown at the top of the
// drawer body when a draft-like request is not ready to send. Follows
// the same layout as RussiaRequestDrawerReturnBanner so the visual
// weight is consistent. Hidden when the request is send-ready or not in
// a draft-like status.

import { useTranslation } from 'react-i18next';
import { Icon } from '../../../ui/index.js';
import { missingToMessageKey } from './russiaDrawerSendReadiness.js';

export function RussiaRequestDrawerSendReadinessHint({ missing }: { missing: string[] }) {
  const { t } = useTranslation('russiaRequests');
  if (missing.length === 0) return null;
  const msgKey = missingToMessageKey(missing);
  return (
    <div
      data-testid="russia-request-drawer-send-readiness-hint"
      style={{
        margin: '12px 18px 0',
        padding: '12px 14px',
        background: 'var(--status-info-bg)',
        borderRadius: 'var(--r-2)',
        display: 'flex',
        gap: 10,
        flex: 'none',
      }}
    >
      <Icon
        name="circle-dot"
        size={16}
        style={{ color: 'var(--status-info-fg)', flex: 'none', marginTop: 1 }}
      />
      <div>
        <div
          style={{
            fontSize: 12,
            fontWeight: 600,
            color: 'var(--status-info-fg)',
            marginBottom: 2,
          }}
        >
          {t('drawer.sendReadiness.title')}
        </div>
        <div style={{ fontSize: 13, color: 'var(--fg-1)' }}>{t(msgKey)}</div>
      </div>
    </div>
  );
}
